import { AccountType } from "@/modules/account/common/enum";
import { LoanType } from "@/modules/loan/common/enum";
import { ActivePaths } from "@/shared/common/constants";
import { AppPaths, CloudflareAsset, FeatureToggle } from "@/shared/common/enums";
import type { ISidebarMenuItem } from "@/shared/common/types";
import { CloudFlareImage } from "@/shared/components";
import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";

export const sidebarMenuItem: ISidebarMenuItem[] = [
  {
    id: 1,
    group: {
      label: "sidebar.myFinances",
      activePath: ActivePaths.MyFinances,
      icon: {
        Component: (props: ISVGIconProps) => (
          <CloudFlareImage {...props} path={CloudflareAsset.Card}/>
        ),
      },
      children: [
        {
          id: 2,
          label: "sidebar.accounts",
          href: AppPaths.Accounts,
          params: { type: AccountType.SettlementAccount },
          activePath: ActivePaths.Accounts,
        },
        {
          id: 3,
          label: "sidebar.cards",
          href: AppPaths.Cards,
          activePath: ActivePaths.Cards,
        },
        {
          id: 5,
          label: "sidebar.deposits",
          href: AppPaths.Deposits,
          activePath: ActivePaths.Deposits,
        },
        {
          id: 6,
          label: "sidebar.loans",
          href: AppPaths.Loans,
          params: { type: LoanType.Standard },
          activePath: ActivePaths.Loans,
        },
        {
          id: 7,
          label: "sidebar.stocks",
          href: AppPaths.Stocks,
          activePath: ActivePaths.Stocks,
        },
        {
          id: 8,
          label: "sidebar.bonds",
          href: AppPaths.Bonds,
          activePath: ActivePaths.Bonds,
        },
      ],
    },
  },
  {
    id: 9,
    group: {
      label: "sidebar.banking",
      activePath: ActivePaths.Banking,
      icon: {
        Component: (props: ISVGIconProps) => (
          <CloudFlareImage {...props} path={CloudflareAsset.Transfer}/>
        ),
      },
      children: [
        {
          id: 10,
          label: "sidebar.transfers",
          href: AppPaths.Transactions,
          activePath: ActivePaths.Transactions,
        },
        {
          id: 11,
          label: "sidebar.templates",
          href: AppPaths.Templates,
          activePath: ActivePaths.Templates,
          featureFlag: FeatureToggle.isTemplatesAvailable,
        },
      ],
    },
  },
  {
    id: 40,
    item: {
      id: 41,
      label: "sidebar.beneficiaries",
      icon: {
        Component: (props: ISVGIconProps) => (
          <CloudFlareImage {...props} path={CloudflareAsset.Beneficiaries}/>
        ),
      },
      href: AppPaths.Beneficiaries,
      activePath: ActivePaths.Beneficiaries,
      featureFlag: FeatureToggle.isBeneficiaryAvailable,
    },
  },
  {
    id: 22,
    item: {
      id: 23,
      label: "sidebar.applications",
      icon: {
        Component: (props: ISVGIconProps) => (
          <CloudFlareImage {...props} path={CloudflareAsset.Application}/>
        ),
      },
      href: AppPaths.Applications,
      activePath: ActivePaths.Applications,
    },
  },
  {
    id: 32,
    group: {
      label: "sidebar.history",
      activePath: ActivePaths.History,
      icon: {
        Component: (props: ISVGIconProps) => (
          <CloudFlareImage {...props} path={CloudflareAsset.History}/>
        ),
      },
      children: [
        {
          id: 33,
          label: "sidebar.transactionHistory",
          href: AppPaths.TransactionHistory,
          activePath: ActivePaths.TransactionHistory,
        },
        {
          id: 34,
          label: "sidebar.applicationHistory",
          href: ActivePaths.ApplicationHistory,
          activePath: ActivePaths.ApplicationHistory,
        },
      ],
    },
  },
];
